import { List } from '@mui/material'

import { MobileBottomLayout, PaginationButtons } from 'src/components'
import { UserSessionsGridItem } from './user-sessions-grid-item.component'
import { IUserSessionsDto } from 'src/types'

interface IErrorLogsGridProps {
  usersSessions?: IUserSessionsDto[] | void
}

const UserSessionsGrid = ({ usersSessions }: IErrorLogsGridProps) => {
  return (
    <>
      <List sx={{ width: '100%' }}>
        {usersSessions?.map((item) => (
          <UserSessionsGridItem item={item} key={item.id} />
        ))}
      </List>
      <MobileBottomLayout>
        <PaginationButtons buttonsOnly />
      </MobileBottomLayout>
    </>
  )
}

export { UserSessionsGrid }
